// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2Fv18","Open":"SideDrawer_Open__383I6","Close":"SideDrawer_Close__1uArX","spacer":"SideDrawer_spacer__3xxR2"};